// src/people/MinimizedBuilder.jsx

import React from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import { useGLTF }         from "@react-three/drei";

export default function MinimizedBuilder({ base, accessories }) {
  return (
    <div style={{ width: 200, height: 200 }}>
      <Canvas camera={{ position: [0, 1, 4], fov: 45 }}>
        <ambientLight intensity={2.5} />
        <directionalLight position={[5, 5, 5]} />

        {/* This child is inside <Canvas>, so it CAN use useFrame */}
        <RotatingGroup base={base} accessories={accessories} />
      </Canvas>
    </div>
  );
}

function RotatingGroup({ base, accessories }) {
  const ref = React.useRef();

  useFrame(({ clock }) => {
    if (!ref.current) return;
    // ±22.5° swing on Y
    const amplitude = Math.PI / 8;
    const speed     = 1.2;
    ref.current.rotation.y = Math.sin(clock.getElapsedTime() * speed) * amplitude;
  });

  return (
    <group ref={ref} position={[0, -5, 0]} scale={[3.5, 3.5, 3.5]}>
      <Model url={`/models/${base}.glb`} />
      {accessories.map((a) => (
        <Model key={a} url={`/models/${a}.glb`} />
      ))}
    </group>
  );
}

function Model({ url }) {
  const { scene } = useGLTF(url);
  return <primitive object={scene} dispose={null} />;
}
